let SHOP = 'nbn-data-setup.myshopify.com';
let STOREFRONT_TOKEN = '70bc02637513e57dbfafb5526e3972f6';
  console.log('window.shop',window.shop)
if(window.shop == 'golftechuk.myshopify.com'){
   SHOP = 'ninebyninegolf.myshopify.com';
   STOREFRONT_TOKEN = 'b50c3ff4d3d2cbc7da628ad6c1fa6343';
}

const API_VERSION = '2025-10'; // change if needed
// Fetch only shaft products by product_type using Storefront API (paginated).
// Node/browser (fetch must be available). Replace SHOP and STOREFRONT_TOKEN.

const FLEX_GROUPS = {
  Ladies: [
    "ladies", "l", "regular 3", "sf305", "4.0", "3.5", "m0", "f1"
  ],
  Senior: [
    "senior", "a", "soft regular", "sf305x", "5.0", "f2", "regular 2", "m1"
  ],
  Regular: [
    "regular", "r", "regular 1", "sf405", "5.5", "f3", "regular +", "r300", "m2"
  ],
  Stiff: [
    "stiff", "s", "stiff regular", "sf505", "6.0", "f4", "s200", "stiff +", "m3"
  ],
  "X-Stiff": [
    "x stiff", "xstiff", "x", "sf505x", "6.5", "f5", "x100", "m4", "m5"
  ],
  "Tour X-Stiff": [
    "tour x stiff", "tx", "tx (tour x-stiff)", "7.0", "sf505xx"
  ]
};

const STATIC_HEADS = {
  hybrid: ["2", "3", "4", "5", "6", "I’m not sure"],
  default: ["Driver", "3", "3HL", "5", "7", "9", "11", "I’m not sure"]
};



async function shopifyGraphQL(query, variables = {}) {
  const url = `https://${SHOP}/api/${API_VERSION}/graphql.json`;
  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
    },
    body: JSON.stringify({ query, variables })
  });
  if (!res.ok) throw new Error(`HTTP ${res.status} - ${await res.text()}`);
  const payload = await res.json();
  if (payload.errors) throw new Error(JSON.stringify(payload.errors));
  return payload.data;
}

/**
 * Fetch shafts by product_type values.
 *
 * types: array of product_type strings e.g. ['Iron Shaft','Wood Shaft']
 * opts:
 *   pageSize: products per page (default 100, max around 250)
 *   variantFirst: how many variants to fetch per product page (default 50)
 *   variantSkus: optional array of SKUs to narrow returned variants (case-insensitive)
 *
 * Returns: [{ id, title, productType, variants: [{ id, title, sku, priceAmount, available }] }, ...]
 */
async function fetchShaftsByTypes(types = ['Iron Shaft','Wood Shaft'], opts = {}) {
  const pageSize = opts.pageSize || 100;
  const variantFirst = opts.variantFirst || 50;
  const variantSkus = (opts.variantSkus || []).map(s => (s||'').toString().toLowerCase());
  // build product_type query: product_type:'Iron Shaft' OR product_type:'Wood Shaft'
  const safeParts = types.map(t => `product_type:'${String(t).replace(/'/g,"\\'")}'`);
  const typeQuery = safeParts.join(' OR ');

  let after = null;
  const out = [];

  while (true) {
    const query = /* GraphQL */ `
      query GetShafts($first: Int!, $after: String, $query: String!, $variantFirst: Int!, $country: CountryCode) @inContext(country: $country) {
        products(first: $first, after: $after, query: $query) {
          edges {
            cursor
            node {
              id
              handle
              title
              vendor
              productType
              availableForSale
              featuredImage{
                url
              }
             shortDescription: metafield(namespace:"custom",key:"short_description"){
                value
                id
              }
               recommended: metafield(namespace:"custom",key:"is_recommended"){
                value
                id
                }
                zeroUpcharge: metafield(namespace:"custom",key:"is_zero_upcharge"){
                value
                id
                }
                default_length: metafield(namespace:"custom",key:"default_length"){
                  value          
                  id
                }
               tip_size: metafield(namespace:"custom",key:"tip_size"){
                  value          
                  id
                }
               neck: metafield(namespace:"custom",key:"neck"){
                  value          
                  id
                }
               tip_fit: metafield(namespace:"custom",key:"tip_fit"){
                  value          
                  id
                }
               neck_fit: metafield(namespace:"custom",key:"neck_fit"){
                  value          
                  id
                }
               material: metafield(namespace:"custom",key:"material"){
                  value          
                  id
                }
               pre_selected_grip: metafield(namespace:"custom",key:"pre_selected_grip"){
                  value          
                  id
                }
               pre_selected_shaft: metafield(namespace:"custom",key:"pre_selected_shaft"){
                  value          
                  id
                }
               ball_spin: metafield(namespace:"custom",key:"ball_spin"){
                  value          
                  id
                }
               ball_flight: metafield(namespace:"custom",key:"ball_flight"){
                  value          
                  id
                }
               shaft_profile: metafield(namespace:"custom",key:"shaft_profile"){
                  value          
                  id
                }
              shaftThumb: metafield(namespace: "custom", key: "shaftThumb") {
                  value
                  id
                  type
                  reference {
                    __typename
                    ... on MediaImage {
                      image {
                        url
                        altText
                        width
                        height
                      }
                    }
                  }
                }
                gripthumb: metafield(namespace: "custom", key: "gripthumb") {
                  value
                  id
                  type
                  reference {
                    __typename
                    ... on MediaImage {
                      image {
                        url
                        altText
                        width
                        height
                      }
                    }
                  }
                }
              variants(first: $variantFirst) {
                pageInfo { hasNextPage }
                edges {
                  node {
                    id
                    title
                    sku
                    price { amount currencyCode }
                    selectedOptions{
                      name
                      value
                    }
                    default_length: metafield(namespace:"custom",key:"default_length"){
                      value          
                      id
                    }
                    iron_fit: metafield(namespace:"custom",key:"iron_fit"){
                      value          
                      id
                    }
                    iron: metafield(namespace:"custom",key:"iron"){
                      value          
                      id
                    }
                  }
                }
              }
            }
          }
          pageInfo { hasNextPage }
        }
      }
    `;
    const variables = { first: pageSize, after, query: typeQuery, variantFirst, country: Shopify?.country || "GB" };
    const data = await shopifyGraphQL(query, variables);
    const edges = (data.products && data.products.edges) || [];

    for (const edge of edges) {
      const p = edge.node;
      // flatten first page of variants
      let variants = (p.variants.edges || []).map(e => {
        const v = e.node;

        // Convert selectedOptions array → object
        const optionMap = {};
        (v.selectedOptions || []).forEach(opt => {
          optionMap[opt.name.toLowerCase()] = opt.value;
        });

        return {
          id: v.id,
          title: v.title,
          sku: v.sku,
          priceAmount: v.price ? Number(v.price.amount) : null,

          // raw options
          options: optionMap,

          // normalized fields (what your UI actually needs)
          flex: optionMap.flex || null,
          model: optionMap.model || null,
        };
      });


      // if variantSkus provided but not all SKUs present on first page, you can page remaining variants.
      // For performance we only fetch remaining variants if variantSkus is provided AND some requested SKUs are missing.
      const skusRequested = variantSkus.length > 0;
      if (skusRequested) {
        const presentSkus = new Set(variants.map(v => (v.sku||'').toLowerCase()));
        const missing = variantSkus.filter(sku => !presentSkus.has(sku));
        if (missing.length && p.variants.pageInfo && p.variants.pageInfo.hasNextPage) {
          // fetch all variants for this product (page through) to find requested SKUs
          const more = await fetchAllVariantsForProduct(p.id);
          // append unique variants
          const existingIds = new Set(variants.map(v => v.id));
          for (const mv of more) {
            if (!existingIds.has(mv.id)) {
              variants.push(mv);
            }
          }
        }
        // filter to only requested SKUs (case-insensitive)
        variants = variants.filter(v => variantSkus.includes((v.sku||'').toLowerCase()));
      }

      // console.log('product shortDescription:: ',renderShopifyRTE(p.shortDescription?.value))
      // if variantSkus not provided, we keep whatever variants were fetched (first page)
      out.push({
        id: p.id,
        handle: p.handle,
        title: p.title,
        productType: p.productType,
        vendor: p.vendor,
        featuredImage: p.featuredImage.url,
        variants:variants,
        availableForSale:p.availableForSale,
        recommended:p.recommended?.value || false,
        zeroUpcharge:p.zeroUpcharge?.value || false,
        default_length:p.default_length?.value || "",
        tip_size:p.tip_size?.value || "",
        neck_fit:p.neck_fit?.value || "",
        material:p.material?.value || "",
        ball_flight:p.ball_flight?.value || "",
        ball_spin:p.ball_spin?.value || "",
        shaft_profile:p.shaft_profile?.value || "",
        pre_selected_grip:p.pre_selected_grip?.value || false,
        shortDescription:renderShopifyRTE(p.shortDescription?.value) || "",
        shaftThumb:p.shaftThumb,
        gripthumb:p.gripthumb,
      });
    }

    if (!data.products.pageInfo.hasNextPage) break;
    after = edges.length ? edges[edges.length - 1].cursor : null;
    if (!after) break;
  }

  return out;
}

/**
 * Helper: fetch all variants for a product (cursor-based). Returns same variant shape used above.
 * Use only when necessary (keeps normal calls fast).
 */
async function fetchAllVariantsForProduct(productGid) {
  const perPage = 50;
  let after = null;
  const all = [];
  while (true) {
    const query = /* GraphQL */ `
      query ProductVariants($id: ID!, $first: Int!, $after: String, $country: CountryCode) @inContext(country: $country) {
        node(id: $id) {
          ... on Product {
            variants(first: $first, after: $after) {
              pageInfo { hasNextPage }
              edges {
                node { id title sku price { amount currencyCode } }
                cursor
              }
            }
          }
        }
      }
    `;
    // Map the currency to a Country Code if Shopify.country isn't available
    const countryMapping = { 'USD': 'US', 'GBP': 'GB', 'EUR': 'FR', 'SEK': 'SE', 'CAD': 'CA' };
    const activeCountry = Shopify?.country || countryMapping[Shopify.currency.active] || 'GB';
    const data = await shopifyGraphQL(query, { id: productGid, first: perPage, after, country: activeCountry });
    const edges = (data.node && data.node.variants && data.node.variants.edges) || [];
    for (const e of edges) {
      const v = e.node;
      all.push({
        id: v.id,
        title: v.title,
        sku: v.sku,
        priceAmount: v.price ? v.price.amount : null
      });
    }
    if (!(data.node && data.node.variants && data.node.variants.pageInfo && data.node.variants.pageInfo.hasNextPage)) break;
    after = edges.length ? edges[edges.length - 1].cursor : null;
    if (!after) break;
  }
  return all;
}

function getShopifyImageUrl(src, { width, height, crop } = {}) {
  if (!src || typeof src !== 'string') return src;

  // Ignore non-Shopify CDN images
  if (!src.includes('cdn.shopify.com')) return src;

  // Split query params
  const [url, query] = src.split('?');

  // Extract extension
  const match = url.match(/\.(jpg|jpeg|png|webp)$/i);
  if (!match) return src;

  const ext = match[0];
  const base = url.replace(ext, '');

  // Build size suffix
  let size = '';
  if (width && height) size = `_${width}x${height}`;
  else if (width) size = `_${width}x`;

  // Rebuild URL
  let finalUrl = `${base}${size}${ext}`;
  if (query) finalUrl += `?${query}`;

  // Optional crop (center, top, etc.)
  if (crop) {
    finalUrl += (query ? '&' : '?') + `crop=${crop}`;
  }

  return finalUrl;
}


// Get the current club config from your JSON
const currentClubConfig = CONFIG.shaft_type[currentProduct?.type]; // e.g., "Driver"

// Helper to calculate final price
const getFinalPrice = (basePrice, discountPercent) => {
    const discountAmount = (basePrice * (discountPercent || 0)) / 100;
    const finalPrice = basePrice - discountAmount;
    return Math.max(0, finalPrice); // Ensure price never goes below 0
};



function normalizeBool(val) {
  return val === true || val === 'true' || val === 1 || val === '1';
}

function getProductImage(product) {
  return (
    product?.shaftThumb?.reference?.image?.url ||""
  );
}

function getProductImageGrip(product) {
  return (
    product?.gripthumb?.reference?.image?.url ||""
  );
}

function getBrandConfigForCurrentHead() {
  const vendor = (window.currentProduct?.vendor || "").toLowerCase();
  if (!vendor) return null;

  return META_BRANDS.find(
    b => (b.title || "").toLowerCase() === vendor
  ) || null;
}


function getNumericProductId(gid) {
  if (!gid) return null;

  const match = String(gid).match(/Product\/(\d+)/);
  return match ? Number(match[1]) : null;
}

function renderShopifyRTE(rte) {
  if (!rte) return "";

  let data;
  try {
    data = typeof rte === "string" ? JSON.parse(rte) : rte;
  } catch (e) {
    return "";
  }

  if (!data || !Array.isArray(data.children)) return "";

  return data.children.map(renderRTENode).join("");
}

function renderRTENode(node) {
  if (!node) return "";

  switch (node.type) {
    case "paragraph":
      return `<p>${(node.children || []).map(renderRTENode).join("")}</p>`;

    case "text": {
      let text = escapeHtml(node.value || "");

      if (node.bold) text = `<strong>${text}</strong>`;
      if (node.italic) text = `<em>${text}</em>`;

      return text.replace(/\n/g, "<br>");
    }

    case "heading": {
      const level = node.level || 3;
      return `<h${level}>${(node.children || [])
        .map(renderRTENode)
        .join("")}</h${level}>`;
    }

    case "list":
      const tag = node.listType === "ordered" ? "ol" : "ul";
      return `<${tag}>${(node.children || [])
        .map(renderRTENode)
        .join("")}</${tag}>`;

    case "list-item":
      return `<li>${(node.children || [])
        .map(renderRTENode)
        .join("")}</li>`;

    default:
      return "";
  }
}

function escapeHtml(str) {
  return str
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

function buildInfoAccordion(rteDescription) {
  const html = rteDescription;
  if (!html) return "";

  return `
    <div class="nbn-info-accordion">
      <button class="nbn-info-toggle" type="button">
        INFO +
      </button>
      <div class="nbn-info-content">
        ${html}
      </div>
    </div>
  `;
}



function extractProductIdFromMetafield(value) {
  if (!value) return null;

  // CASE 1: Shopify already gives numeric product ID (YOUR CASE)
  if (typeof value.id === 'number') {
    return value.id;
  }

  // CASE 2: id is a GID string
  if (typeof value.id === 'string') {
    return getNumericProductId(value.id);
  }

  // CASE 3: whole value is a GID string
  if (typeof value === 'string') {
    return getNumericProductId(value);
  }

  return null;
}




function getPreSelectedShaftNumericId() {
  const mf = window.currentProduct?.metafields?.pre_selected_shaft;
  const resolved = extractProductIdFromMetafield(mf);

  // console.log('[DEBUG] pre_selected_shaft raw:', mf);
  // console.log('[DEBUG] resolved numeric ID:', resolved);

  return resolved;
}

function getAdapterOptions() {
  const brand = getBrandConfigForCurrentHead();
  if (!brand || !Array.isArray(brand.adapter_settings)) {
    return null;
  }

  return {
    options: brand.adapter_settings,
    default: brand.default_adapter || brand.adapter_settings[0]
  };
}

function renderAdapterDropdown(container) {
  const cfg = getAdapterOptions();
  if (!cfg) return;

  const optionsHtml = cfg.options
    .map(opt => `
      <option value="${opt}" ${opt === cfg.default ? "selected" : ""}>
        ${opt}
      </option>
    `)
    .join("");

  const html = `
  <div class="nbn-advanced">  
  <div class="nbn-shaft-adapter nbn-custom-select">
      <label>Adaptor</label>
      <select id="shaft-adapter-select">
        ${optionsHtml}
      </select>
    </div>
  </div>
  `;

  container.insertAdjacentHTML("beforeend", html);

  // Persist selection
  container
    .querySelector("#shaft-adapter-select")
    ?.addEventListener("change", e => {
      window.__selectedAdapter = e.target.value;
    });

  // default
  window.__selectedAdapter = cfg.default;
}

function buildSpineTooltip() {
  return `
    <div class="nbn-tooltip">
      <p>
        Aligning the shaft’s natural spine to ensure consistent performance and reduce unwanted flex
      </p>
    </div>
  `;
}



function getLengthConfigForCurrentHead() {
  const shaftType = window.__shaftProduct?.type;
  if (!shaftType) return null;

  const shaftCfg = CONFIG?.shaft_type?.[shaftType];
  if (!shaftCfg || !shaftCfg.length_to_pull) return null;

  return window.META_LENGTHS.find(
    l => l.for_type === shaftCfg.length_to_pull
  ) || null;
}


function normalizeFlexValue(raw) {
  if (!raw) return '';

  return raw
    .toString()
    .toLowerCase()
    .replace(/\//g, ' ')
    .replace(/\+/g, ' plus')
    .replace(/\s+/g, ' ')
    .trim();
}

function resolveFlexGroup(variantFlexText) {
  const norm = normalizeFlexValue(variantFlexText);

  for (const [group, aliases] of Object.entries(FLEX_GROUPS)) {
    if (aliases.some(a => norm.includes(a))) {
      return group;
    }
  }

  return null; // unknown / uncategorized
}



/**
 * Grips Helper Starts
 */

function formatKey(key) {
  return key.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());
}

function buildShaftOptionSummary(variant) {
  if (!variant || !variant.options) {
    return { optionLabel: "", optionValue: "" };
  }

  const entries = Object.entries(variant.options);

  return {
    optionLabel: entries.map(([k]) =>
      k.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase())
    ).join(" / "),
    optionValue: entries.map(([, v]) => v).join(" / ")
  };
}

function drawerClose(id) {
  const drawer = document.getElementById(id);
  if (!drawer) return;
  drawer.classList.remove("active");
}



/************** 
 * Grips Helper Starts
 * **************
 */

function getPreSelectedGripNumericId() {
  return extractProductIdFromMetafield(
    window.currentProduct?.metafields?.pre_selected_grip
  );
}
function updateGripPriceUI() {
  const el = document.querySelector('.nbn-grip-price');
  // 1. Safety checks: element exists, grip is selected, and config is available
  if (!el || !window.__selectedGrip || !currentClubConfig) return;

  // 2. Calculate the price
  const minBasePrice = Math.min(...window.__selectedGrip.product.variants.map(v => v.price));
  
  // Use GRIP discount here, not shaft
  const discount = currentClubConfig.grip_discount_amount || 0;
  
  // Assuming getFinalPrice is defined globally as discussed:
  const finalPrice = getFinalPrice(minBasePrice, discount);

  // 3. Render the HTML
  const isZeroUpcharge = normalizeBool(window.__selectedGrip.product.zeroUpcharge) || finalPrice <= 0;

  el.innerHTML = getPriceDisplayHTML(minBasePrice,discount,window.__selectedGrip.product.zeroUpcharge,'grip')
}

function initPreSelectedGrip(grips) {
  const preId = getPreSelectedGripNumericId();
  if (!preId) return;

  const grip = grips.find(g => getNumericProductId(g.productId) === preId);
  if (!grip || !grip.variants.length) return;

  // console.log('selected grip product',grip)
  
  const v = grip.variants[0];
  const { label, value } = buildVariantOptionSummary(v.options);
  const summary = buildShaftOptionSummary(v);
  window.__selectedGrip = {
    productId: grip.productId,
    productTitle: grip.productTitle,
    variantId: v.variantId,
    price: Number(v.price||0) ,
    featuredImage: grip.featuredImage,
    brand: grip.vendor,
    ...summary,
    product:grip,
    variant:v,
  };

  // console.log('window.__selectedGrip',window.__selectedGrip)

  updateSelectedGripLabel(window.__selectedGrip);
  renderSelectedGripSummary(window.__selectedGrip);

  updateBuildPrice();
  updateGripPriceUI();

  // console.log('window.__selectedGrip 766',window.__selectedGrip)
  if (window.__selectedGrip) {
    renderGripVariantRadios(window.__selectedGrip.product);
  }
  if(document.getElementById("open-grip-drawer")){
      document.getElementById("open-grip-drawer").style.display ='block';
  }
}

async function initGripFlow() {
  const headType = currentProduct.type;
  const cfg = CONFIG?.shaft_type?.[headType];
  // console.log('cfg',cfg)
  
  if (!cfg?.grips_to_pull) return;

  let grips = await fetchShaftsByTypes(
    cfg.grips_to_pull.map(normalizeProductTypeLabel),
    { pageSize: 50, variantFirst: 50 }
  );

  // 1. Group by product
  // console.log('grips',grips)
  const groupedGrips = groupGripsByProduct(flattenGrips(grips));
  // console.log('groupedGrips',groupedGrips)
  

  // 2. Sort into buckets
  const buckets = {
    recommended: [],
    zeroUpcharge: [],
    others: []
  };

  groupedGrips.forEach(grip => {
    const preId = getPreSelectedGripNumericId(); 
    const isPreSelected = getNumericProductId(grip.productId) === preId;
    
    if (isPreSelected) {
      buckets.recommended.push(grip);
    } else if (normalizeBool(grip.zeroUpcharge)) {
      buckets.zeroUpcharge.push(grip);
    } else {
      buckets.others.push(grip);
    }
  });

  // 3. SET THE STATE
  // initPreSelectedGrip usually handles what shows on the main product page initially
  initPreSelectedGrip(groupedGrips);

  // 4. INITIALIZE THE DRAWER
  // We pass 'buckets' here. The drawer init function will handle the rendering 
  // of results inside the drawer so we don't have to call it twice.
  initGripDrawer(buckets);
  
  // console.log('Grip Flow Initialized with Buckets:', buckets);
}

function renderGroupedGripBuckets(buckets) {
  const container = document.getElementById('grip-results');
  if (!container) return;
  container.innerHTML = '';

  // 1. Render Recommended (Will hide automatically if empty)
  renderGripSection('Recommended for You', buckets.recommended);

  // 2. Render Zero Upcharge (Will hide automatically if empty)
  renderGripSection('Zero Upcharge Grips', buckets.zeroUpcharge);

  // 🔥 FIX 2: Determine if "All Grips" should be collapsed
  // We only collapse "All Grips" if there is at least one item in the priority sections above it.
  const hasPriorityItems = (buckets.recommended?.length > 0) || (buckets.zeroUpcharge?.length > 0);
  const shouldCollapseOthers = hasPriorityItems;

  // 3. Render All Others
  renderGripSection('All Grips', buckets.others, shouldCollapseOthers);
}

function renderGripSection(title, products, collapsible = false) {
  // 🔥 FIX 1: If there are no products, exit immediately to hide the header
  if (!products || products.length === 0) return;

  const container = document.getElementById('grip-results');
  const section = document.createElement('div');
  section.className = 'shaft-section grip-section'; 

  section.innerHTML = `
    <h3 class="shaft-section-title">${title}</h3>
    <div class="shaft-section-list"></div>
  `;

  const list = section.querySelector('.shaft-section-list');
  products.forEach(p => renderGripProduct(p, list));

  // Only collapse if requested AND we actually have content to hide
  if (collapsible) {
    section.classList.add('is-collapsed');
  }

  container.appendChild(section);
}

function flattenGrips(products) {
  // console.log('grup products:: ',products)
  const out = [];
  products.forEach(p => {
    (p.variants || []).forEach(v => {
      out.push({
        productId: p.id,
        productTitle: p.title,
        variantTitle: v.title,
        featuredImage: getShopifyImageUrl(p.featuredImage, { width: 280 }),
        variantId: v.id,
        vendor: p.vendor,
        available: p.availableForSale,
        price: Number(v.priceAmount||0),                
        shortDescription: p.shortDescription || '',
        short_title: p.short_title || '',
        recommended: p.recommended || false,
        zeroUpcharge: p.zeroUpcharge || false,
        options:v.options,
        gripthumb:p.gripthumb,
        shaftThumb:p.shaftThumb,
      });
    });
  });
  return out;
}

function groupGripsByProduct(items) {
  const map = new Map();

  items.forEach(i => {
    // console.log('grip map ',i)
    if (!map.has(i.productId)) {
      map.set(i.productId, {
        productId: i.productId,
        productTitle: i.productTitle,
        variantTitle: i.variantTitle,
        featuredImage: i.featuredImage,
        variantId: i.variantId,
        vendor: i.vendor,
        available: i.availableForSale,
        price: Number(i.priceAmount||0),                
        shortDescription: i.shortDescription || '',
        short_title: i.short_title || '',
        recommended: i.recommended || false,
        zeroUpcharge: i.zeroUpcharge || false,
        options:i.options,
        gripthumb:i.gripthumb,
        shaftThumb:i.shaftThumb,
        variants: []
      });
    }
    map.get(i.productId).variants.push({
      variantId: i.variantId,
      price: i.price,
      color: i.color,
      size: i.size,
      price: Number(i.price || 0),
      available: i.available,
      options:i.options,
      variantTitle:i.variantTitle
    });
  });

  return [...map.values()];
}

function bindShowAllGripsButton() {
  const btn = document.getElementById('show-all-grips-btn');
  if (!btn) return;

  // Remove existing listeners to prevent duplicates if init is called multiple times
  const newBtn = btn.cloneNode(true);
  btn.parentNode.replaceChild(newBtn, btn);

  newBtn.addEventListener('click', () => {
    expandAllGripSections();
    // After expanding, we check if we need to hide the button
    updateShowAllGripsButton();
  });

  // Initial check to see if button should be visible
  updateShowAllGripsButton();
}

function expandAllGripSections() {
  // Target only grip sections specifically
  document
    .querySelectorAll('#grip-results .shaft-section.is-collapsed') 
    .forEach(section => section.classList.remove('is-collapsed'));
}

function updateShowAllGripsButton() {
  const btn = document.getElementById('show-all-grips-btn');
  if (!btn) return;

  // Logic: Show button ONLY if filters are NOT active AND there are hidden sections
  const show = !hasActiveGripFilters() && hasCollapsedGripSections();
  
  btn.style.display = show ? 'block' : 'none';
}

function hasCollapsedGripSections() {
  // Returns true if any section in the grip results is currently collapsed
  return document.querySelectorAll('#grip-results .shaft-section.is-collapsed').length > 0;
}

function hasActiveGripFilters() {
  // Check your specific ID for the grip brand filter dropdown
  const brandFilter = document.getElementById('grip-brand-select'); // or 'grip-brand-filter'
  
  // If filter exists and value is not "All", return true
  return brandFilter && brandFilter.value !== 'all' && brandFilter.value !== '';
}


function populateGripBrandFilter(grips) {
  const sel = document.getElementById("filter-grip-brand");
  if (!sel) return;

  // Reset with "All" option
  sel.innerHTML = `<option value="__all__" selected>All brands</option>`;

  const brands = [...new Set(grips.map(g => g.vendor).filter(v => v && v.trim()))].sort();

  brands.forEach(b => {
    const o = document.createElement("option");
    o.value = b;
    o.textContent = b;
    sel.appendChild(o);
  });
}


function bindGripFilters() {
  const vendorSelect = document.getElementById("filter-grip-brand");
  const searchInput = document.getElementById("grip-search");
  
  if (!vendorSelect || !searchInput) return;

  const handleFilter = () => {
    const selectedVendor = vendorSelect.value;
    const searchText = searchInput.value.toLowerCase().trim();

    // Check if any filter is actually active (assuming empty string or "__all__" is default)
    const isFilterActive = (selectedVendor !== "__all__" && selectedVendor !== "") || searchText !== "";

    // --- SCENARIO 1: NO FILTERS ACTIVE ---
    // Restore the original "Recommended / Zero Upcharge" layout
    if (!isFilterActive) {
      renderGroupedGripBuckets(window.__gripBuckets);
      updateShowAllGripsButton(); // Show the "Show All" button if sections are collapsed
      return;
    }

    // --- SCENARIO 2: FILTERS ACTIVE ---
    // 1. Flatten the buckets so we can search through EVERYTHING
    const allGrips = [
      ...(window.__gripBuckets.recommended || []),
      ...(window.__gripBuckets.zeroUpcharge || []),
      ...(window.__gripBuckets.others || [])
    ];

    // 2. Apply Filters
    const filtered = allGrips.filter(grip => {
      // Check Brand/Vendor
      const matchesVendor = (selectedVendor === "__all__" || selectedVendor === "") || 
                            grip.vendor === selectedVendor;
      
      // Check Search Text
      const matchesSearch = !searchText || 
                            (grip.productTitle && grip.productTitle.toLowerCase().includes(searchText)) || 
                            (grip.vendor && grip.vendor.toLowerCase().includes(searchText));

      return matchesVendor && matchesSearch;
    });

    // 3. Render "Search Results" Mode
    const container = document.getElementById('grip-results');
    container.innerHTML = ''; // Clear current view

    if (filtered.length > 0) {
      // Reuse renderGripSection to keep styling consistent, but don't collapse it
      renderGripSection(`All Grips`, filtered, false);
    } else {
      container.innerHTML = '<div class="no-results" style="padding: 20px; text-align: center;">No grips found matching your criteria.</div>';
    }

    // 4. Update Button Visibility
    // This effectively hides the "Show All" button while searching, which is good UX
    updateShowAllGripsButton();
  };

  // Listen for dropdown changes
  vendorSelect.addEventListener("change", handleFilter);

  // Listen for typing in the search box
  searchInput.addEventListener("input", handleFilter);
}


function initGripDrawer(buckets) {
  const drawer = document.getElementById("grip-drawer");
  if (!drawer) return;

  // 1. Accordion Logic (Info Toggles)
  // We use a named function to prevent duplicate listeners if init is called twice
  const handleAccordionClick = e => {
    const toggle = e.target.closest(".nbn-info-toggle");
    if (!toggle) return;
    e.stopPropagation();
    e.preventDefault();
    const accordion = toggle.closest(".nbn-info-accordion");
    accordion.classList.toggle("open");
  };
  
  // Clean up old listener before adding (good practice)
  document.removeEventListener("click", handleAccordionClick);
  document.addEventListener("click", handleAccordionClick);

  // 2. Close Logic
  document.getElementById("close-grip-drawer")
    ?.addEventListener("click", () => drawer.classList.remove("active"));

  // 3. Store Buckets Globally 
  // We store the whole bucket object so filters can access specific sections if needed
  window.__gripBuckets = buckets;

  // 4. Flatten all grips for the Brand Filter
  // Filters usually need a single list of all unique brands
  const allGripsFlat = [
    ...buckets.recommended, 
    ...buckets.zeroUpcharge, 
    ...buckets.others
  ];
  
  populateGripBrandFilter(allGripsFlat);

  // 5. Render the grouped UI
  // Instead of a flat list, we render the sections
  renderGroupedGripBuckets(buckets);

  // 6. Bind UI filters
  bindGripFilters();

  // 7. 🔥 BIND THE SHOW ALL BUTTON HERE
  bindShowAllGripsButton();

  // 8. Open Drawer Listeners
  document.querySelectorAll("#open-grip-drawer, #open-grip-drawer-btn").forEach(btn =>
    btn.addEventListener("click", (e) => {
      drawer.classList.add("active");
    })
  );
}

// /**
//  * Calculates price after fixed discount and returns formatted HTML
//  * @param {number} basePrice - The raw price (e.g., 50.00)
//  * @param {number} discountAmount - The fixed £ to subtract (e.g., 35)
//  * @param {boolean} isZeroUpcharge - The product's zeroUpcharge flag
//  * @param {string} unit - 'shaft' or 'grip'
//  */
// function getPriceDisplayHTML(basePrice, discountAmount, isZeroUpcharge, unit) {
//     // Simple subtraction for fixed amounts
//     const finalPrice = Math.max(0, basePrice - (discountAmount || 0));

//     if (normalizeBool(isZeroUpcharge) || finalPrice <= 0) {
//         return `<div class="price price-zero">Zero Upcharge</div>`;
//     } else {
//         // toFixed(2) ensures it still looks like £15.00
//         return `<div class="price Math-min">+${theme.currencySymbol}${finalPrice.toFixed(2)}/${unit}</div>`;
//     }
// }

/**
 * @param {number|string} shaftPrice - Price from GraphQL (already converted/rounded by Shopify)
 * @param {number} discountBase - Discount in GBP (e.g., 35)
 * @param {boolean} isZeroUpcharge - Metafield check
 * @param {string} unit - Label (e.g., "shaft")
 */
function getPriceDisplayHTML(shaftPrice, discountBase, isZeroUpcharge, unit = "shaft") {
    const { rate = 1.0, active = 'GBP' } = Shopify.currency || {};
    const marketFee = (active === 'GBP') ? 1.0 : 1.02; // Accounts for the 2% fee in your Market settings

    // 1. Normalize input to decimal (not cents) to make raw math easier
    let currentPrice = parseFloat(shaftPrice);
    
    // 2. Convert the Discount to the current Market currency
    // GBP Discount * Exchange Rate * 2% Fee
    const convertedDiscount = Number(discountBase) * parseFloat(rate) * marketFee;

    // 3. Subtract from the already-rounded price (raw math)
    const finalPrice = Math.max(0, currentPrice - convertedDiscount);

    if (isZeroUpcharge || finalPrice <= 0) {
        return `<div class="price price-zero">Zero Upcharge</div>`;
    }

    // 4. Formatting - Removed the applyMarketRounding call here
    
    // Using Intl.NumberFormat to force 2 decimal places regardless of currency settings
    const formattedPrice = new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: active,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(finalPrice);

    return `<div class="price">+${formattedPrice}/${unit}</div>`;
}


function renderGripProduct(grip, container) {
  const v = grip.variants[0];
  const el = document.createElement("div");
  
  // Clean up class logic: Use 'current-selected' as the primary state class
  el.className = "option_product";
  el.dataset.vendor = grip.vendor;

  // --- 1. INITIAL HIGHLIGHT CHECK ---
  // Ensure the product stays highlighted if the drawer is re-rendered
  if (window.__selectedGrip && window.__selectedGrip.productId === grip.productId) {
    el.classList.add('current-selected');
  }

  // Inside your grip loop/render function
  const gripPrice = Math.min(...grip.variants.map(v => v.price));
  const gripDiscount = currentClubConfig?.grip_discount_amount || 0;
  el.innerHTML = `
    <div class="option">
      <div class="option_head">
        <h4>${grip.short_title || grip.productTitle}</h4>
        ${getPriceDisplayHTML(gripPrice, gripDiscount, grip.zeroUpcharge, 'grip')}        
      </div>
      <div class="option_img">
        <img src="${getProductImageGrip(grip)}" loading="lazy">
      </div>
    </div>
  `;

  el.addEventListener('click', () => {
    // --- 2. UPDATE VISUAL SELECTION STATE ---
    // We target the entire results container to clear selection across ALL sections (Recommended/Others)
    document.querySelectorAll('#grip-results .option_product').forEach(item => {
      item.classList.remove('current-selected');
    });
    
    // Add class to the clicked element
    el.classList.add('current-selected');

    const variant = grip.variants.find(v => v.available) || grip.variants[0];
    const summary = buildShaftOptionSummary(variant);

    // Update Global State
    window.__selectedGrip = {
      productId: grip.productId,
      productTitle: grip.productTitle,
      variantId: variant.variantId,
      price: Number(variant.price || 0),
      featuredImage: grip.featuredImage,
      vendor: grip.vendor,
      ...summary,
      product: grip,
      variant: variant
    };

    // --- 3. UI UPDATES ---
    updateSelectedGripLabel(window.__selectedGrip);
    renderSelectedGripSummary(window.__selectedGrip);
    
    // Renders the size/color radios for the specific grip chosen
    renderGripVariantRadios(grip);

    updateBuildPrice();
    updateGripPriceUI();

    // Close drawer and show the "Change Grip" button
    document.getElementById("grip-drawer")?.classList.remove("active");
    const openBtn = document.getElementById("open-grip-drawer");
    if (openBtn) {
      openBtn.style.display = 'block';
    }
  });

  container.appendChild(el);

  // Remove error state if selection is made
  const configStep = document.querySelector("#grip-step .gd-config");
  if (configStep) configStep.classList.remove('has-error');
}

function updateSelectedGripLabel(grip) {
  // console.log('updateSelectedGripLabel grip',grip)
  const el = document.getElementById("selected-grip-name");
  if (!el || !grip) return;

  el.innerHTML = `
    ${grip.productTitle}
    <br>
    <div class="shaft-meta">
      <span class="shaft-meta-label">${grip.optionLabel || ''}</span><br>
      <strong class="shaft-meta-value">${grip.optionValue || ''}</strong>
    </div>
  `;

  // TRIGGER RESET HERE
  validateBuildAndMarkErrors(); 
  updateOrderButtonState();
}

function bindGripOptionEvents() {
  const logoToggle = document.getElementById("grip-logo-toggle");
  const tapeSelect = document.getElementById("grip-tape-select");

  if (logoToggle) {
    logoToggle.addEventListener("change", e => {
      window.__selectedGripOptions.logoOrientation =
        e.target.checked ? "down" : "up";

      console.log("Grip logo:", window.__selectedGripOptions.logoOrientation);
    });
  }

  if (tapeSelect) {
    tapeSelect.addEventListener("change", e => {
      window.__selectedGripOptions.gripTape = e.target.value;

      console.log("Grip tape:", window.__selectedGripOptions.gripTape);
    });
  }

  bindLogoOrientationToggle();
}

function renderGripVariantRadios(product) {
  if (!product || !product.variants?.length) return;

  renderVariantRadios({
    variants: product.variants,
    selectedVariant: window.__selectedGrip?.variant,
    containerId: "grip-variant-options",
    onChange: v => {
      window.__selectedGrip.variant = v;
      window.__selectedGrip.variantId = v.variantId;
      window.__selectedGrip.price = Number(v.price || 0);

      const summary = buildShaftOptionSummary(v);
      window.__selectedGrip.optionLabel = summary.optionLabel;
      window.__selectedGrip.optionValue = summary.optionValue;

      updateSelectedGripLabel(window.__selectedGrip);
      updateBuildPrice();
    }
  });
}


function renderVariantRadios({ variants, selectedVariant, onChange, containerId }) {
  const container = document.getElementById(containerId);
  if (!container || !variants.length) return;

  container.innerHTML = "";

  // 1. Filter variants for Wedges if necessary
  let effectiveVariants = variants;
  const isWedge = false;
  // const isWedge = window.currentProduct?.type === 'Wedge';
  // if (isWedge) {
  //   effectiveVariants = variants.filter(v => {
  //     const iron = v.options?.iron?.toLowerCase();
  //     return iron === 'pw' || iron === '9i';
  //   });
  // }

  // 2. Define the keys we are working with (e.g., ["model", "flex"])
  // We exclude 'iron' for wedges as per your requirement
  const optionKeys = Object.keys(effectiveVariants[0].options || {})
                           .filter(key => !(isWedge && key === 'iron'));

  // 3. Determine currently selected variant
  let current = selectedVariant && effectiveVariants.find(v => v.variantId === selectedVariant.variantId)
                ? selectedVariant 
                : effectiveVariants.find(v => v.available) || effectiveVariants[0];

  // 4. Iterate through keys to build dependent UI
  let filteredPool = effectiveVariants;

  optionKeys.forEach((key, index) => {
    // For the CURRENT key, we show values available in the filtered pool 
    // (the pool was filtered by the PREVIOUS selection)
    const availableValues = [...new Set(filteredPool.map(v => v.options[key]))].filter(Boolean);

    // If we want to show ALL values but disable ones that don't match, 
    // we use the master 'effectiveVariants' list for the UI:
    const allPossibleValuesForKey = [...new Set(effectiveVariants.map(v => v.options[key]))].filter(Boolean);

    container.insertAdjacentHTML("beforeend", `
      <div class="variant-group" data-option="${key}">
        <label>${key.replace(/_/g, " ")}</label>
        <div class="variant-radios" data-key="${key}"></div>
      </div>
    `);

    const wrap = container.querySelector(`[data-key="${key}"]`);

    allPossibleValuesForKey.forEach(val => {
      // Logic: Is this value valid given what was selected in the options ABOVE it?
      const isPossible = availableValues.includes(val);
      const isChecked = current.options[key] === val;

      wrap.insertAdjacentHTML("beforeend", `
        <label class="radio-option ${isPossible ? "" : "hidden-option disabled"}">
          <input type="radio"
                 name="${containerId}-${key}"
                 value="${val}"
                 ${isChecked ? "checked" : ""}
                 ${isPossible ? "" : "disabled"}>
          <span>${val}</span>
        </label>
      `);
    });

    // 5. CRITICAL: Narrow the pool for the NEXT option based on current selection
    const currentSelectionForKey = current.options[key];
    filteredPool = filteredPool.filter(v => v.options[key] === currentSelectionForKey);
  });

  // 6. Bind events to trigger re-render
  bindVariantRadioEvents({
    variants: effectiveVariants,
    containerId,
    onChange
  });
}

function bindVariantRadioEvents({ variants, containerId, onChange }) {
  const container = document.getElementById(containerId);

  container.querySelectorAll("input[type=radio]").forEach(radio => {
    radio.addEventListener("change", () => {
      const selections = {};
      container.querySelectorAll("input:checked").forEach(r => {
        const key = r.name.replace(containerId + "-", "");
        selections[key] = r.value;
      });

      // Find the best matching variant
      // 1. Try to find exact match
      let next = variants.find(v => 
        Object.entries(selections).every(([k, val]) => v.options[k] === val)
      );

      // 2. If no exact match (because options changed), find first available with current first selection
      if (!next) {
        const firstKey = Object.keys(selections)[0];
        next = variants.find(v => v.options[firstKey] === selections[firstKey] && v.available) || 
               variants.find(v => v.options[firstKey] === selections[firstKey]);
      }

      if (next) {
        onChange(next);
        renderVariantRadios({
          variants,
          selectedVariant: next,
          containerId,
          onChange
        });
      }
    });
  });
}

function renderSelectedGripSummary(grip) {
  if (!grip) return;

  const container = document.querySelector("#grip-step .js-set-selected-Grip");
  if (!container) return;

  // console.log('selcted grip',grip)
  // Inside your grip loop/render function
  const gripPrice = Math.min(...grip.product.variants.map(v => v.price));
  const gripDiscount = currentClubConfig?.grip_discount_amount || 0;
    container.innerHTML = `
      <div class="nbn-step-card">
        <div class="nbn-step-right">

          <div class="nbn-grip-price">
            ${getPriceDisplayHTML(gripPrice, gripDiscount, grip.zeroUpcharge, 'grip')}
          </div>
          <div class="nbn-grip-image">
            <img
              src="${getProductImageGrip(grip.product)}"
              alt="${grip.productTitle}"
              loading="lazy"
              width="420"
            />
          </div>

          <!-- GRIP VARIANT OPTIONS -->
          <div id="grip-variant-options" class="nbn-variant-options"></div>

          <!-- LOGO ORIENTATION -->
          <div class="nbn-grip-logo">
            <div class="nbn-advanced">
              <div class="gd-toggle">
                <button class="gd-toggle-btn" data-logoorientation="Up" aria-pressed="true">Logo Up</button>
                <label class="gd-switch" aria-hidden="true">
                  <input type="checkbox" class="gd-switch-input">
                  <span class="gd-switch-slider"></span>
                </label>
                <button class="gd-toggle-btn" data-logoorientation="Down" aria-pressed="false">Logo Down</button>
              </div>
          </div>
          

          <!-- GRIP TAPE -->
          <div class="nbn-grip-tape nbn-custom-select">
            <label for="grip-tape-select">Grip Tape</label>

            <select id="grip-tape-select">
              <option value="1 Layer (Standard)" selected>1 Layer (Standard)</option>
              <option value="2 Layers">2 Layers</option>
              <option value="3 Layers">3 Layers</option>
              <option value="4 Layers">4 Layers</option>
            </select>
          </div>
          </div>

        </div>
      </div>
    `;

  bindGripOptionEvents();
  bindLogoOrientationToggle();   // ← ADD THIS

}


/************** 
 * Grips Helper Ends
 * **************
 */





// ========== All Helper Ends ==========

// ========== USAGE EXAMPLES ==========
window.__selectedGrip = null;
window.__selectedGripOptions = {
  logoOrientation: "up",        // up | down
  gripTape: "1 Layer (Standard)"
};


function updateBuildPrice() {
  // 1. Failsafe Data Retrieval
  const head = window.__selectedHeadVariant;
  const shaft = window.__selectedShaft;
  const grip = window.__selectedGrip;
  const adapterObj = window.__selectedAdaptor;
  const isSpineActive = !!window.__spineAlignment;

  // NEW: Get Config for Discounts
  const currentClubConfig = CONFIG.shaft_type[currentProduct?.type];
  const shaftDiscount = Number(currentClubConfig?.shaft_discount_amount || 0);
  const gripDiscount = Number(currentClubConfig?.grip_discount_amount || 0);

  // 2. Calculations with Failsafes
  
  // Head Price (Never discounted)
  const basePrice = Number(head?.price || 0) / 100;

  // Shaft Price - Discount applied only to upcharge
  let shaftPrice = 0;
  if (shaft && shaft.zeroUpcharge !== true && shaft.zeroUpcharge !== "true") {
    const rawShaftPrice = Number(shaft.price || 0);
    const normalizedShaft = rawShaftPrice > 1000 ? rawShaftPrice / 100 : rawShaftPrice;
    // Ensure shaft price doesn't go below 0
    shaftPrice = Math.max(0, normalizedShaft - shaftDiscount);
  }

  // Adapter Price
  let adapterPrice = 0;
  if (adapterObj && adapterObj.variants && adapterObj.variants.length > 0) {
    const rawAdapterPrice = Number(adapterObj.variants[0].price || 0);
    adapterPrice = rawAdapterPrice / 100;
  }

  // Grip Price - Discount applied only to upcharge
  let gripPrice = 0;
  if (grip && grip.zeroUpcharge !== true && grip.zeroUpcharge !== "true") {
    const rawGripPrice = Number(grip.variant?.price || grip.price || 0);
    const normalizedGrip = rawGripPrice > 1000 ? rawGripPrice / 100 : rawGripPrice;
    // Ensure grip price doesn't go below 0
    gripPrice = Math.max(0, normalizedGrip - gripDiscount);
  }

  // Spine Alignment
  const spinePrice = isSpineActive ? Number(window.spine_alignment.price / 100) : 0;

  // 3. Grand Total
  adapterPrice = 0; //adapter has 100% discount for custom shafts
  const total = basePrice + shaftPrice + adapterPrice + gripPrice + spinePrice;

  // 4. DOM Updates
  const priceElements = document.querySelectorAll('[data-product-price], .unit-price span');
  priceElements.forEach(el => {
    if (el) el.textContent = `${theme.currencySymbol}${total.toFixed(2)}`;
  });

  // 5. Update Global Build State
  window.__currentBuild = {
    headVariant: head,
    adapterVariant: adapterObj?.variants ? adapterObj.variants[0] : null,
    shaftVariant: shaft,
    grip: grip,
    spine: spinePrice,
    appliedDiscounts: {
      shaft: shaftDiscount,
      grip: gripDiscount
    },
    total: total
  };
}

function normalizeHand(v) {
  return (v || '')
    .toString()
    .toLowerCase()
    .replace(' hand', '')
    .trim();
}

function normalizeLoft(v) {
  return (v || "")
    .toString()
    .replace(/[°˚]/g, "")   // remove both degree symbols
    .replace(/\s+/g, "")
    .toLowerCase();
}



function normalizeProductTypeLabel(label) {
  if (!label || typeof label !== 'string') return label;

  let s = label.trim();
  s = s.replace(/\s+/g, ' ');
  s = s.replace(/Shafts$/i, 'Shaft');
  s = s.replace(/shafts$/i, 'Shaft'); // defensive

  return s;
}



function buildVariantOptionSummary(options = {}) {
  const entries = Object.entries(options);

  if (!entries.length) {
    return {
      label: "",
      value: ""
    };
  }

  const label = entries
    .map(([key]) =>
      key
        .replace(/_/g, " ")
        .replace(/\b\w/g, c => c.toUpperCase())
    )
    .join(" / ");

  const value = entries
    .map(([, val]) => val)
    .join(" / ");

  return { label, value };
}



function buildLengthOptionsHtml(lengthConfig) {
  if (!lengthConfig) return '<option>No lengths available</option>';

  return lengthConfig.length_values
    .map(val => {
      const selected =
        val === lengthConfig.default_length ? 'selected' : '';
      return `<option ${selected}>${val}</option>`;
    })
    .join('');
}



document.addEventListener('change', e => {
  if (e.target?.id === 'shaft-length-select') {
    // console.log(e.target,e.target.value)
    window.__selectedShaftLength = e.target.value;
  }
});

document.addEventListener("click", e => {
  const btn = e.target.closest(".nbn-info-toggle");
  if (!btn) return;

  const accordion = btn.closest(".nbn-info-accordion");
  accordion.classList.toggle("open");
});

document.addEventListener("click", e => {
  if (e.target.closest(".nbn-info-content")) {
    e.stopPropagation();
  }
});

document
  .querySelector(".nbn-drawer-overlay")
  ?.addEventListener("click", e => {
    if (e.target !== e.currentTarget) return;
    drawerClose("shaft-drawer");
  });



function bindLogoOrientationToggle() {
  const wrap = document.querySelector('#grip-step .gd-toggle');
  if (!wrap) return;

  const buttons = wrap.querySelectorAll('.gd-toggle-btn[data-logoorientation]');
  const switchInput = wrap.querySelector('.gd-switch-input');

  function setOrientation(value) {
    buttons.forEach(btn => {
      btn.setAttribute(
        'aria-pressed',
        btn.dataset.logoorientation === value ? 'true' : 'false'
      );
    });

    if (switchInput) {
      switchInput.checked = value === 'Down';
    }
  }

  buttons.forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();
      setOrientation(btn.dataset.logoorientation);
    });
  });

  if (switchInput) {
    switchInput.addEventListener('change', e => {
      e.stopPropagation();
      setOrientation(switchInput.checked ? 'Down' : 'Up');
    });
  }
}




/************
 * Add to cart functions start
 *************/

function toShopifyVariantId(gid) {
  return Number(gid.replace('gid://shopify/ProductVariant/', ''));
}

function getSelectedAdapter() {
  const el = document.getElementById('shaft-adapter-select');
  return el && el.value ? el.value : null;
}

function getSelectedShaftLength() {
  const el = document.getElementById('shaft-length-select');
  return el && el.value ? el.value : null;
}

function getSelectedSpineVariant() {
  const el = document.getElementById('shaft-spine-select');
  if (!el || !el.checked) return null;
  return Number(el.value);
}

/* ================================================================
   STAFF-ONLY BUILD SPECS  (custom shaft configurator)
   ----------------------------------------------------------------
   Unlike the driver and iron configurators, ALL FOUR fields are
   rendered in Liquid here, because this PDP's option markup is static
   Liquid rather than JS-injected. Nothing wipes them, so there is no
   value cache and no re-bind step -- this file only needs to read the
   values at add-to-cart time.

   Fields: #staff-swing-weight, #staff-tipping,
           #staff-total-weight, #staff-head-weight
   ================================================================ */

function isStaffCustomer() {
  if (typeof window.staffCustomer !== 'undefined') return !!window.staffCustomer;
  // Fallback: the Liquid staff blocks only render for tagged customers.
  return !!document.querySelector('[data-nbn-staff-only]');
}

/**
 * Staff spec properties for the cart payload. Blank fields are omitted,
 * so a non-staff payload is unchanged.
 */
function getStaffBuildSpecs() {
  if (!isStaffCustomer()) return {};

  const read = id => (document.getElementById(id)?.value || '').trim();

  const swingWeight = read('staff-swing-weight');
  const tipping     = read('staff-tipping');
  const totalWeight = read('staff-total-weight');
  const headWeight  = read('staff-head-weight');

  return {
    ...(swingWeight && { 'Swing Weight': swingWeight }),
    ...(tipping     && { 'Tipping': `${tipping}"` }),
    ...(totalWeight && { 'Total Weight': `${totalWeight}g` }),
    ...(headWeight  && { 'Head Weight': `${headWeight}g` })
  };
}

function getSelectedGripTape() {
  const el = document.getElementById('grip-tape-select');
  return el && el.value ? el.value : null;
}

function getSelectedLogoOrientation() {
  const active = document.querySelector(
    '#grip-step .gd-toggle-btn[data-logoorientation][aria-pressed="true"]'
  );
  return active ? active.dataset.logoorientation : null;
}



function isBuildComplete() {
  const b = window.__currentBuild;
  const emailInput = document.getElementById('email');
  
  // Elements for the Hosel/Adapter validation
  const fixedHoselCheck = document.getElementById('fixed-hosel-checkbox');
  const brandSel   = document.getElementById('adaptor-brand-select');
  const modelSel   = document.getElementById('adaptor-model-select');
  const headSel    = document.getElementById('adaptor-head-select');
  const settingSel = document.getElementById('adaptor-setting-select');

  // 1. Basic Build & Grip Check
  if (!b || !window.__selectedGrip) return false;

  // 2. Email Validation (Regex check)
  if (!emailInput) return false;
  const email = emailInput.value.trim();
  if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return false;

  // 3. Hosel OR Adapter Logic
  const isFixedHosel = fixedHoselCheck && fixedHoselCheck.checked;
  
  if (!isFixedHosel) {
    // If NOT fixed hosel, ensure all 4 adapter dropdowns have values
    const adapterComplete = brandSel?.value && modelSel?.value && headSel?.value && settingSel?.value;
    if (!adapterComplete) return false;
  }

  // If all checks pass
  return true;
}


function updateOrderButtonState() {
  const btn = document.getElementById('orderSubmitButton');
  if (!btn) return;

  const ready = isBuildComplete();
  console.log('isBuildComplete:: ',ready)
  btn.disabled = !ready;
  btn.classList.toggle('is-disabled', !ready);
}


function bindBuildValidation() {

  function shouldTrigger(e) {
    const t = e.target;
    
    return (
      t.matches?.('.gd-iron-input') ||
      t.matches?.('#shaft-length-select') ||
      t.matches?.('#fixed-hosel-checkbox') || // The Toggle
      // --- ADD THESE NEW SELECTORS ---
      t.matches?.('#adaptor-brand-select') ||
      t.matches?.('#adaptor-model-select') ||
      t.matches?.('#adaptor-head-select') ||
      t.matches?.('#adaptor-setting-select') ||
      // -------------------------------
      t.matches?.('#shaft-adapter-select') ||
      t.matches?.('#iron-loft-select') ||
      t.matches?.('#iron-lie-select') ||
      t.matches?.('#grip-tape-select') ||
      t.matches?.('#email') ||
      t.matches?.('#shaft-spine-select') ||
      t.matches?.('input[name="shaft-variant-options-flex"]') ||
      t.matches?.('input[name="shaft-variant-options-model"]') ||
      t.closest?.('.gd-toggle-btn[data-hand]')
    );
  }

  // Helper function that actually updates the UI
  window.updateOrderButtonState = function() {
    const btn = document.getElementById('add-to-cart-btn'); // Replace with your actual ID
    if (!btn) return;

    const isReady = isBuildComplete(); 
    
    btn.disabled = !isReady;
    // Optional styling to show the button is locked
    btn.style.opacity = isReady ? "1" : "0.5";
    btn.style.cursor = isReady ? "pointer" : "not-allowed";
  };

  document.addEventListener('change', e => {
    if (shouldTrigger(e)) {
      updateOrderButtonState();
    }
  });

  document.addEventListener('input', e => {
    if (e.target.matches?.('#email')) {
      updateOrderButtonState();
    }
  });

  document.addEventListener('click', e => {
    if (
      e.target.closest?.('.gd-toggle-btn[data-hand]') ||
      e.target.matches?.('#shaft-spine-select')
    ) {
      updateOrderButtonState();
    }
  });
}



function getSelectedNativeVariantId() {
  const input = document.querySelector('form[action="/cart/add"] [name="id"]');
  return input ? Number(input.value) : null;
}

/**
 * Returns selected product/variant info based on format:
 * 'both'  -> "Product Title - Variant Title"
 * 'variant' -> "Variant Title"
 * 'product' -> "Product Title"
 */
function getSelectedVariantTitle(format = 'variant') {
  const selectedId = window.__selectedShaft.id;
  
  if (!selectedId || !window.currentProduct || !window.currentProduct.variants) {
    return null;
  }

  const variant = window.currentProduct.variants.find(v => v.id === selectedId);
  if (!variant) return null;

  const productTitle = window.currentProduct.title;
  const variantTitle = variant.title;

  switch (format) {
    case 'both':
      return `${productTitle} - ${variantTitle}`;
    case 'product':
      return productTitle;
    case 'variant':
    default:
      return variantTitle;
  }
}

/* ================================================================
   PHONE NUMBER — capture, validate, normalise
   ----------------------------------------------------------------
   Field markup lives in snippets/nbn-phone-field.liquid (id
   #quote-phone). This block reads it, validates the format and
   normalises to E.164 (+447700900123) so the value is consistent
   whether it reaches a draft order, a cart attribute or the Admin API.

   Guarded on window so the three configurator bundles can never
   collide with a duplicate-declaration SyntaxError.
   ================================================================ */

window.NBNPhone = window.NBNPhone || (function () {

  /* ISO-3166 alpha-2 -> country calling code.
     Only used to expand NATIONAL format input (e.g. 07700 900123).
     Numbers typed with a leading + or 00 bypass this entirely, so an
     absent country here degrades to "please include your country
     code" rather than to a wrong number. Extend as markets open. */
  const DIAL = {
    GB:'44', IE:'353', US:'1', CA:'1', AU:'61', NZ:'64', IN:'91',
    FR:'33', DE:'49', ES:'34', IT:'39', PT:'351', NL:'31', BE:'32',
    LU:'352', CH:'41', AT:'43', DK:'45', SE:'46', NO:'47', FI:'358',
    IS:'354', PL:'48', CZ:'420', SK:'421', HU:'36', RO:'40', BG:'359',
    GR:'30', HR:'385', SI:'386', RS:'381', EE:'372', LV:'371', LT:'370',
    CY:'357', MT:'356', JP:'81', CN:'86', HK:'852', SG:'65', MY:'60',
    TH:'66', KR:'82', TW:'886', PH:'63', ID:'62', VN:'84', AE:'971',
    SA:'966', QA:'974', KW:'965', BH:'973', OM:'968', IL:'972',
    TR:'90', ZA:'27', EG:'20', MA:'212', NG:'234', KE:'254',
    MX:'52', BR:'55', AR:'54', CL:'56', CO:'57', PE:'51'
  };

  function dialFor(cc) {
    return DIAL[String(cc || '').toUpperCase()] || null;
  }

  function defaultCountry(el) {
    return (el && el.dataset && el.dataset.defaultCountry)
      || (window.MARKET_CONTEXT && window.MARKET_CONTEXT.country)
      || (window.Shopify && window.Shopify.country)
      || '';
  }

  /**
   * @returns {{ok:boolean, empty:boolean, e164:string, reason:string}}
   */
  function normalise(raw, countryCode) {
    const input = String(raw == null ? '' : raw).trim();

    if (!input) {
      return { ok: false, empty: true, e164: '', reason: 'Enter a phone number.' };
    }

    if (/[A-Za-z]/.test(input)) {
      return { ok: false, empty: false, e164: '', reason: 'Phone number cannot contain letters.' };
    }

    // Strip the punctuation people actually type.
    let s = input.replace(/[\s().\-\/]/g, '');
    let international = false;

    if (s.charAt(0) === '+') {
      international = true;
      s = s.slice(1);
    } else if (s.slice(0, 2) === '00') {
      international = true;      // 00 is the international access prefix
      s = s.slice(2);
    }

    if (!/^\d+$/.test(s)) {
      return { ok: false, empty: false, e164: '', reason: 'Use digits, spaces and + only.' };
    }

    if (!international) {
      const dial = dialFor(countryCode);
      if (!dial) {
        return {
          ok: false, empty: false, e164: '',
          reason: 'Include your country code, e.g. +44 7700 900123.'
        };
      }
      s = s.replace(/^0+/, '');   // drop the national trunk prefix
      if (!s) {
        return { ok: false, empty: false, e164: '', reason: 'Enter a valid phone number.' };
      }
      s = dial + s;
    }

    // E.164 allows a maximum of 15 digits including the country code.
    if (s.length < 8)  return { ok: false, empty: false, e164: '', reason: 'That number looks too short.' };
    if (s.length > 15) return { ok: false, empty: false, e164: '', reason: 'That number looks too long.' };
    if (/^(\d)\1+$/.test(s)) return { ok: false, empty: false, e164: '', reason: 'Enter a valid phone number.' };

    return { ok: true, empty: false, e164: '+' + s, reason: '' };
  }

  return { normalise, defaultCountry, dialFor, DIAL };
})();

function getPhoneFieldEl() {
  return document.getElementById('quote-phone');
}

/** Normalised E.164 value, or '' when absent/blank/invalid. */
function getQuotePhone() {
  const el = getPhoneFieldEl();
  if (!el) return '';
  const res = window.NBNPhone.normalise(el.value, window.NBNPhone.defaultCountry(el));
  return res.ok ? res.e164 : '';
}

function showPhoneError(msg) {
  const el = getPhoneFieldEl();
  if (!el) return;
  if (typeof setFieldError === 'function') setFieldError(el, !!msg);
  const errEl = document.getElementById('quote-phone-error');
  if (errEl) {
    errEl.textContent = msg || '';
    errEl.hidden = !msg;
  }
}

/** True when the field is absent, or blank-and-optional, or valid. */
function validatePhoneField() {
  const el = getPhoneFieldEl();
  if (!el) return true;

  const required = el.dataset.required === 'true';
  const raw = (el.value || '').trim();

  if (!raw) {
    if (required) { showPhoneError('Phone number is required.'); return false; }
    showPhoneError('');
    return true;
  }

  const res = window.NBNPhone.normalise(raw, window.NBNPhone.defaultCountry(el));
  showPhoneError(res.ok ? '' : res.reason);
  return res.ok;
}

/* Writes the phone onto the CART as an attribute, so it survives into
   the order as a note attribute. That is the hook a Shopify Flow (or a
   webhook on your app) needs in order to write it back to the customer
   record — the storefront cannot update customer.phone directly. */
async function persistPhoneToCart() {
  // No field on this page — leave whatever the cart already carries alone.
  if (!getPhoneFieldEl()) return;

  // Present but empty clears the attribute ('' removes it), otherwise a number
  // staff deleted would keep riding along on the next quote.
  const phone = getQuotePhone();
  try {
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { 'Phone Number': phone } })
    });
  } catch (err) {
    // Never block the add-to-cart on this.
    console.error('Phone attribute update failed', err);
  }
}

/* Validate on blur; while typing, only clear an error that is already
   showing, so the customer is not scolded mid-entry. */
document.addEventListener('blur', function (e) {
  if (e.target && e.target.id === 'quote-phone') validatePhoneField();
}, true);

document.addEventListener('input', function (e) {
  if (!e.target || e.target.id !== 'quote-phone') return;
  const errEl = document.getElementById('quote-phone-error');
  const showing = errEl && !errEl.hidden;
  if (showing) validatePhoneField();
});

function setFieldError(el, hasError) {
  if (!el) return;

  const wrapper =
    el.closest('.gd-config') ||
    el.closest('.config-section') ||
    el.parentElement;

  if (hasError) {
    wrapper?.classList.add('has-error');
  } else {
    wrapper?.classList.remove('has-error');
  }
}

function validateBuildAndMarkErrors() {
  let valid = true;

  // 1. Grip Validation
  const gripBtn = document.getElementById('open-grip-drawer-btn');
  if (!window.__selectedGrip) {
    setFieldError(gripBtn, true);
    valid = false;
  } else {
    setFieldError(gripBtn, false); // Resets error when grip is present
  }

  // 2. Email Validation
  const emailEl = document.getElementById('email');
  if (emailEl) {
    const emailValid = emailEl.value && emailEl.value.includes('@');
    setFieldError(emailEl, !emailValid);
    if (!emailValid) valid = false;
  }

  // 3. Hosel vs. Adapter Logic
  const fixedHoselCheck = document.getElementById('fixed-hosel-checkbox');
  const adapters = [
    document.getElementById('adaptor-brand-select'),
    document.getElementById('adaptor-model-select'),
    document.getElementById('adaptor-head-select'),
    document.getElementById('adaptor-setting-select')
  ];

  const isFixed = fixedHoselCheck && fixedHoselCheck.checked;
  const adapterComplete = adapters.every(el => el && el.value);

  if (isFixed || adapterComplete) {
    // If EITHER is true, clear errors from all adapter fields
    adapters.forEach(el => setFieldError(el, false));
  } else {
    // If NEITHER is true, mark errors
    adapters.forEach(el => setFieldError(el, true));
    valid = false;
  }

  // Phone number (rendered by snippets/nbn-phone-field.liquid)
  if (!validatePhoneField()) valid = false;

  return valid;
}

function bindImageDrawerOpener({ imageSelector, drawerSelector }) {
  document.addEventListener('click', e => {
    const img = e.target.closest(imageSelector);
    if (!img) return;

    const drawer = document.querySelector(drawerSelector);
    if (!drawer) return;

    e.preventDefault();
    e.stopPropagation();

    drawer.classList.add('active');
  });
}


function mapBuildPayloadToDraftItems(buildPayload) {
  return buildPayload.items.map(item => ({
    variant_id: Number(item.id),
    quantity: item.quantity,
    attributes: Object.entries(item.properties || {}).map(
      ([key, value]) => ({
        key,
        value: String(value)
      })
    )
  }));
}

function buildAddToCartPayload(topLineSKU) {
  const build = window.__currentBuild;
  const items = [];

  const notes = document.querySelector('textarea[name="order_notes"]')?.value || '';


  const adapter = window.__selectedAdaptor;
  const shaftLength = getSelectedShaftLength();
  const gripTape = getSelectedGripTape();
  const logo = getSelectedLogoOrientation();
  const spineVariantId = window.__spineAlignment ? window.spine_alignment?.variants?.[0].id : null;
  const spineVariant = window.__spineAlignment ? window.spine_alignment?.variants?.[0]: null;
  const staffSpecs = getStaffBuildSpecs(); // {} for non-staff

  // ---------- NON-IRON ----------
  const componentParentId = `shaft-${Date.now()}`;
  const selectedVariantId = window.__selectedShaft.id;

  items.push({
    id: selectedVariantId,
    quantity: 1,
    properties: {
      ...(topLineSKU && {"Top Line SKU":topLineSKU}),
      '_component_id': componentParentId,
      '_component_role': 'Main',
      ...(shaftLength && { 'Playing Length': shaftLength }),
      ...(window.__selectedGrip && {"Grip":`${window.__selectedGrip.productTitle} - ${window.__selectedGrip.variant.variantTitle}`}),
      ...(window.__selectedAdaptor && {"Adaptor":`${window.__selectedAdaptor.productTitle}`}),
      ...(spineVariantId && {"Spine Alignment":`Yes (+${formatMoney(spineVariant.price,"£{{amount}}")})`}),
      ...(window.__selectedAdaptor == null && { 'Fixed Hosel': 'Yes' }),
      ...staffSpecs,
      ...(notes && { "Notes":notes, }),
    }
  });

  pushChildren(items, selectedVariantId,componentParentId, build, adapter, gripTape, logo, spineVariantId,spineVariant);

  return { items };
}


function pushChildren(items, parentId, groupId, build, adapter, gripTape, logo, spineVariantId,spineVariant) {

  const currentClubType= window.currentProduct?.type;
  const config = CONFIG.shaft_type[currentClubType];

  console.log('build',build)
  // Shaft
  if (window.__selectedAdaptor) {
    items.push({
      id: (window.__selectedAdaptor.variants[0].id),
      quantity: 1,
      parent_id: parentId, // Shopify native nesting link
      properties: {
        '_component_parent_id': groupId,
        '_component_role': 'Component',
        "For":`${getSelectedVariantTitle("both")}`,
        'Club':`${adapter.brand} ${adapter.club}` || "",
        'Adaptor head':adapter.adapterHead || "",
        'Adaptor setting':adapter.setting || "",
        '_adaptor_discount':'true',
      }
    });
  }

  // Grip
  if (window.__selectedGrip) {
    const gripType = "Swing Grip"; // You seem to use "Swing Grip" as a standard category
    const hasGripDiscount = config.grips_to_pull.includes(gripType);
    const gripDiscountVal = hasGripDiscount ? config.grip_discount_amount : null;
    items.push({
      id: toShopifyVariantId(build.grip.variant.variantId),
      quantity: 1,
      parent_id: parentId, // Shopify native nesting link
      properties: {
        '_component_parent_id': groupId,
        '_component_role': 'Component',
        "For":`${getSelectedVariantTitle("both")}`,
        // Size: build.grip.product?.options?.size || '',
        // Colour: build.grip.product?.options?.color || build.grip.product?.options?.colour || '',
        // ...( !window.staffCustomer && logo && { 'Logo Direction': `Logo ${logo}` } ),
        // ...( !window.staffCustomer && gripTape && { 'Grip Tape': gripTape } ),
        ...(logo && { 'Logo Direction': `Logo ${logo}` } ),
        ...(gripTape && { 'Grip Tape': gripTape } ),
        ...(window.__selectedGrip?.product?.zeroUpcharge === 'true' 
            ? { "_zero_upcharge": true } 
            : (gripDiscountVal !== null ? { [`_grip_discount`]: gripDiscountVal } : {}))
      }
    });
  }

  // Spine
  if (spineVariantId) {
    items.push({
      id: spineVariantId,
      parent_id: parentId, // Shopify native nesting link
      quantity: 1,
      properties: {
        '_component_parent_id': groupId,
        '_component_role': 'Component',
        "For":`${getSelectedVariantTitle("both")}`,
        ...(spineVariantId && {"Spine Alignment":`Yes (+${formatMoney(spineVariant.price,"£{{amount}}")})`}),
      }
    });
  }
}

/************
 * Add to cart functions ends
 *************/

function safeJsonParse(val, fallback = null) {
  if (!val || val === 'undefined') return fallback;
  try {
    return JSON.parse(val);
  } catch {
    return fallback;
  }
}


function mapShaftTypeToCompat(type) {
  if (!type) return null;

  const t = type.toLowerCase();

  if (t.includes('wood')) return 'driver';
  if (t.includes('fairway')) return 'fairway';
  if (t.includes('hybrid')) return 'hybrid';

  return null;
}

function getCompatTypeForCurrentShaft() {
  const t = window.__shaftProduct?.type || '';

  if (/hybrid/i.test(t)) return 'hybrid';
  if (/fairway/i.test(t)) return 'fairway';
  return 'driver'; // wood shafts & drivers
}

function getBrandsWithAdapters() {
  // console.log('getBrandsWithAdapters 1')
  const type = getCompatTypeForCurrentShaft();
  
  // Create a Set of all brands that actually have models for this type
  const brandsWithData = new Set();
  
  Object.values(window.ADAPTOR_COMPAT || {}).forEach(compat => {
    (compat[type] || []).forEach(entry => {
      if (entry.brand) brandsWithData.add(entry.brand);
    });
  });

  // Only return brands that exist in META_BRANDS AND have data in ADAPTOR_COMPAT
  return (window.META_BRANDS || []).filter(b => 
    brandsWithData.has(b.title) && 
    Array.isArray(b.adapter_settings) && 
    b.adapter_settings.length > 0
  );
}

function getCompatModelsForBrand(brand) {
  const result = [];
  const type = getCompatTypeForCurrentShaft();

  Object.entries(window.ADAPTOR_COMPAT || {}).forEach(([handle, compat]) => {
    // Only look at the array for the current type (e.g., 'wood', 'iron')
    const entries = compat[type] || [];
    
    entries.forEach(entry => {
      if (entry.brand === brand) {
        const names = parseProductNames(entry.productNames);
        names.forEach(name => {
          result.push({
            label: name,
            handle,
            variants: compat.variants,
            id: compat.id || null,
            productTitle:compat.productTitle
          });
        });
      }
    });
  });

  // Deduplicate and Sort
  const map = new Map();
  result.forEach(o => map.set(o.label, o));

  return [...map.values()].sort((a, b) =>
    a.label.localeCompare(b.label, undefined, { numeric: true, sensitivity: 'base' })
  );
}



function getHeadsForModel(modelName) {
  const compatType = mapShaftTypeToCompat(window.__shaftProduct?.type);
  if (!compatType) return [];

  const result = [];

  Object.values(window.ADAPTOR_COMPAT || {}).forEach(compat => {
    (compat[compatType] || []).forEach(entry => {
      if (entry.title === modelName) {
        (entry.productNames || []).forEach(n => result.push(n));
      }
    });
  });

  return [...new Set(result)];
}


function parseProductNames(raw) {
  if (!raw || typeof raw !== 'string') return [];

  let s = raw.trim();

  // Case 1: Shopify rendered JSON-like string: ["A","B"]
  if (s.startsWith('[') && s.endsWith(']')) {
    try {
      const parsed = JSON.parse(s.replace(/'/g, '"'));
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  // Case 2: Comma-separated string
  if (s.includes(',')) {
    return s.split(',').map(v => v.trim()).filter(Boolean);
  }

  // Case 3: Single value
  return [s];
}


function getHeadsForCurrentShaft() {
  const t = window.__shaftProduct?.type?.toLowerCase() || '';
  return t.includes('hybrid') ? STATIC_HEADS.hybrid : STATIC_HEADS.default;
}



function initAdaptorStep() {
  const fixedHoselCheckbox = document.getElementById('fixed-hosel-checkbox');
  const brandSel   = document.getElementById('adaptor-brand-select');
  const modelSel   = document.getElementById('adaptor-model-select');
  const headSel    = document.getElementById('adaptor-head-select');
  const settingSel = document.getElementById('adaptor-setting-select');

  if (!brandSel || !modelSel || !headSel || !settingSel) return;

  /* ---------- Helpers ---------- */

  function toggleAdaptorUI(enabled) {
    [brandSel, modelSel, headSel, settingSel].forEach(sel => {
      // console.log('sel',sel,enabled)
      sel.disabled = !enabled;
    });

    if (!enabled) {
      resetSelect(brandSel, 'Select your brand');
      resetSelect(modelSel, 'Select your model');
      resetSelect(headSel, 'Select your clubhead');
      resetSelect(settingSel, 'Adaptor Settings');

      window.__selectedAdaptor = null;
    }
  }

  if (fixedHoselCheckbox) {
    // console.log('fixedHoselCheckbox',fixedHoselCheckbox)
      toggleAdaptorUI(false); // default locked

      fixedHoselCheckbox.addEventListener('change', e => {
        const enabled = e.target.checked;
        // console.log('enabled',enabled)
        toggleAdaptorUI(!enabled);

        if (!enabled) {
          populateSelect(
            brandSel,
            getBrandsWithAdapters().map(b => b.title),
            'Select your brand'
          );
        }

        // Immediately re-run validation to clear/set red borders
        validateBuildAndMarkErrors();
        updateOrderButtonState();
      });
    }



  function resetSelect(select, placeholder, disabled = true) {
    select.innerHTML = `<option value="">${placeholder}</option>`;
    select.disabled = disabled;
  }

  function populateSelect(select, values, placeholder) {
    resetSelect(select, placeholder, false);
    values.forEach(val => {
      const opt = document.createElement('option');
      opt.value = val;
      opt.textContent = val;
      select.appendChild(opt);
    });
  }

  function unique(arr) {
    return [...new Set(arr)];
  }



  function isHybridShaft() {
    const t = window.__shaftProduct?.type?.toLowerCase() || '';
    return t.includes('hybrid');
  }

  function renderModelOptions(models) {
    resetSelect(modelSel, 'Select your model');

      models.forEach(m => {
        const opt = document.createElement('option');
        opt.value = m.label;
        opt.textContent = m.label;
        opt.dataset.handle = m.handle;
        opt.dataset.productId = m.id;
        opt.dataset.productTitle = m.productTitle;
        opt.dataset.variants = JSON.stringify(m.variants || []);
        modelSel.appendChild(opt);
      });

      modelSel.disabled = models.length === 0;
  }

  function renderAdapterSettings(settingsObj) {
    resetSelect(settingSel, 'Adaptor Settings');

    if (!settingsObj || !Array.isArray(settingsObj.values)) return;

    settingsObj.values.forEach(val => {
      const opt = document.createElement('option');
      opt.value = val;
      opt.textContent = val;

      if (settingsObj.default && val === settingsObj.default) {
        opt.selected = true;
      }

      settingSel.appendChild(opt);
    });

    settingSel.disabled = settingsObj.values.length === 0;
  }

  function getAdapterSettingsForSelectedModel(optionEl) {
      if (!optionEl) return [];

      const handle = optionEl.dataset.handle;
      const brand = brandSel.value;

      const compat = window.ADAPTOR_COMPAT?.[handle];
      if (!compat) return [];

      // 1️⃣ Product-level override
      const prodSettings = compat.adapterSettings?.adapter_settings_values;
      if (Array.isArray(prodSettings) && prodSettings.length) {
        return {
          values: prodSettings,
          default: compat.adapterSettings?.default_adapter_setting || null
        };
      }

      // 2️⃣ Brand-level fallback
      const brandCfg = (window.META_BRANDS || []).find(b => b.title === brand);
      return {
        values: brandCfg?.adapter_settings || [],
        default: brandCfg?.default_adapter || null
      };
    }

    function renderHeads() {
      resetSelect(headSel, 'Select your clubhead');

      const heads = getHeadsForCurrentShaft();

      heads.forEach(h => {
        const opt = document.createElement('option');
        opt.value = h;
        opt.textContent = h;
        headSel.appendChild(opt);
      });

      headSel.disabled = heads.length === 0;
    }



  /* ---------- Init ---------- */

  populateSelect(
    brandSel,
    getBrandsWithAdapters().map(b => b.title),
    'Select your brand'
  );

  /* ---------- Brand → Model ---------- */
  brandSel.addEventListener('change', e => {
    if (brandSel.disabled) return;

    resetSelect(modelSel, 'Select your model');
    resetSelect(headSel, 'Select your clubhead');
    resetSelect(settingSel, 'Adaptor Settings');

    const brand = e.target.value;
    const models = getCompatModelsForBrand(brand);
    // console.log('models',models)
    renderModelOptions(models);

     // Immediately re-run validation to clear/set red borders
        validateBuildAndMarkErrors();
        updateOrderButtonState();
  });


  /* ---------- Model → Head ---------- */

  modelSel.addEventListener('change', e => {
    if (modelSel.disabled) return;

    const opt = e.target.selectedOptions[0];
    resetSelect(settingSel, 'Adaptor Settings');

    if (!opt) return;

    renderHeads();

    const settings = getAdapterSettingsForSelectedModel(opt);
    renderAdapterSettings(settings);

    const settingval = document.querySelector("#adaptor-setting-select").value;
    const adapterHead = document.querySelector("#adaptor-head-select").value;
    const BrandHead = document.querySelector("#adaptor-brand-select").value;

    window.__selectedAdaptor = {
      label: opt.value,
      handle: opt.dataset.handle,
      id: opt.dataset.productId,
      setting: settingval,
      club: opt.value,
      brand: BrandHead,
      adapterHead: adapterHead,
      productTitle:opt.dataset.productTitle,
      variants: safeJsonParse(opt.dataset.variants, [])
    };

    updateBuildPrice();

    // console.log('Selected adaptor:', window.__selectedAdaptor);
     // Immediately re-run validation to clear/set red borders
        validateBuildAndMarkErrors();
        updateOrderButtonState();
  });


  document.querySelector(`#adaptor-head-select`).addEventListener('change', e => {
    if (document.querySelector(`#adaptor-head-select`).disabled) return;

    const opt = e.target.selectedOptions[0];
    var adapterHead = opt.value
    window.__selectedAdaptor.adapterHead=adapterHead;
    // console.log('Selected adaptor:', window.__selectedAdaptor);

     // Immediately re-run validation to clear/set red borders
        validateBuildAndMarkErrors();
        updateOrderButtonState();
  });


}


function nativeShaftInit() {
  const container = document.getElementById('shaft-variant-options');
  if (!container || !window.__shaftProduct) return;

  const variants = window.__shaftProduct.variants;
  const groups = Array.from(container.querySelectorAll('.variant-radios'));
  const state = {};

  // Initialize state based on what is currently checked in the DOM
  groups.forEach(group => {
    const checked = group.querySelector('input:checked');
    if (checked) state[group.dataset.key] = checked.value;
  });

  function optionIsEnabled(groupIndex, optionKey, value) {
    return variants.some(v => {
      if (v[optionKey] != value) return false;

      // Only enforce constraints from groups ABOVE this one
      for (let i = 0; i < groupIndex; i++) {
        const keyAbove = groups[i].dataset.key;
        if (state[keyAbove] && v[keyAbove] != state[keyAbove]) return false;
      }
      return true;
    });
  }

  function refreshAvailability(startIndex = 0) {
    for (let i = startIndex; i < groups.length; i++) {
      const group = groups[i];
      const key = group.dataset.key;

      group.querySelectorAll('label').forEach(label => {
        const input = label.querySelector('input');
        const val = input.value;

        const enabled = optionIsEnabled(i, key, val);

        input.disabled = !enabled;
        label.classList.toggle('disabled', !enabled);
      });

      // Auto-fix invalid selection: if current is disabled, pick the first available
      const checked = group.querySelector('input:checked:not(:disabled)');
      if (!checked) {
        const firstEnabled = group.querySelector('input:not(:disabled)');
        if (firstEnabled) {
          firstEnabled.checked = true;
          state[key] = firstEnabled.value;
        }
      } else {
        state[key] = checked.value;
      }
    }
  }

  function syncVariant() {
    const match = variants.find(v =>
      groups.every(g => v[g.dataset.key] == state[g.dataset.key])
    );
    
    // Set the global variable for the cart payload
    window.__selectedShaft = match || null;

    if (match) {
      // console.log('Global __selectedShaft updated:', window.__selectedShaft);
      updateBuildPrice();
    }
  }

  // Event Listener for user changes
  container.addEventListener('change', function (e) {
    const input = e.target;
    if (input.tagName !== 'INPUT') return;

    const group = input.closest('.variant-radios');
    const groupIndex = groups.indexOf(group);

    state[group.dataset.key] = input.value;

    // Refresh dependent options and update the global selected shaft
    refreshAvailability(groupIndex + 1);
    syncVariant();
  });

  // Run initial pass
  refreshAvailability(0);
  syncVariant();
}


let isResetting = false;

function resetAdvancedOptions() {
    // 1. STOP if already running to prevent infinite loop
    if (isResetting) return;
    
    isResetting = true; 
    // console.log("Resetting all advanced options...");

    try {
        // 2. Reset Logo Orientation to "Up"
        const logoSwitch = document.querySelector(".nbn-grip-logo .gd-switch-input");
        if (logoSwitch && logoSwitch.checked !== false) {
            logoSwitch.checked = false;
            logoSwitch.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // 4. Uncheck Spine Alignment
        const spineCheckbox = document.getElementById("shaft-spine-select");
        if (spineCheckbox && spineCheckbox.checked !== false) {
            spineCheckbox.checked = false;
            spineCheckbox.dispatchEvent(new Event('change', { bubbles: true }));
        }
        
    } catch (error) {
        console.error("Error during reset logic:", error);
    } finally {
        // 5. Always unlock the guard at the end
        isResetting = false; 
    }
}


document.addEventListener('DOMContentLoaded', function () {

  async function initConfigurator() {
    if (!window.currentProduct) return;
      // 🔥 Grip MUST be called explicitly
    await initGripFlow();
  }


  nativeShaftInit();

  initConfigurator();  


  // Length and Spine aligment

  const lengthSelect = document.getElementById('shaft-length-select');
  const spineSelect = document.getElementById('shaft-spine-select');

  if (!lengthSelect || !spineSelect) return;

  /* -------- Length -------- */

  function renderLength() {
    const lengthConfig = getLengthConfigForCurrentHead();
    lengthSelect.innerHTML = buildLengthOptionsHtml(lengthConfig);
  }

  /* -------- Spine -------- */

  function renderSpine() {
    const spine = window.spine_alignment;
    if (!spine || !spine.variants) {
      spineSelect.innerHTML = '<option>No spine alignment</option>';
      return;
    }

    spineSelect.innerHTML = spine.variants
      .map(v => `<option value="${v.title}">${v.title}</option>`)
      .join('');

  document.getElementById('shaft-spine-select').addEventListener('change', e => {
    window.__spineAlignment = e.target.checked;
    updateBuildPrice();
  });
  }

  renderLength();
  renderSpine();

  initAdaptorStep();



  const toggle = document.getElementById("advToggle");
    if (!toggle) return;

    // Restore saved state (optional but recommended)
    const saved = localStorage.getItem("nbn_advanced_enabled");
    if (saved === "true") {
      toggle.checked = true;
      document.body.classList.add("nbn-show-advanced");
    }

    toggle.addEventListener("change", () => {
      const enabled = toggle.checked;

      document.body.classList.toggle("nbn-show-advanced", enabled);
      // If Advanced is turned OFF, reset the technical options
        if (!enabled) {
            resetAdvancedOptions();
        }

      // Persist user preference
      localStorage.setItem("nbn_advanced_enabled", enabled);
    });


    bindBuildValidation();
  
  document.getElementById('orderSubmitButton')?.addEventListener('click', async (e) => {
      const submitButton = e.currentTarget;
      
      // 1️⃣ Find the native theme component to borrow its logic
      const productForm = document.querySelector('product-form');

      // 2️⃣ Custom Validation
      const isValid = validateBuildAndMarkErrors();
      if (!isValid) {
        e.preventDefault();
        e.stopPropagation();
        document.querySelector('.has-error')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      // 3️⃣ Native Loading State
      if (submitButton.classList.contains('loading')) return;
      submitButton.classList.add('loading');
      submitButton.setAttribute('aria-disabled', true);

      const topLineSKU = submitButton.getAttribute('data-toplinesku');
      const buildPayload = buildAddToCartPayload(topLineSKU);
      const isQuotation = submitButton.dataset.mode === 'quotation';

      // ☎️ Park the phone on the cart as the "Phone Number" attribute. On live
      // this is the ONLY bridge to the quote: the build page has no quotation
      // submit of its own, so app.js on the cart page reads this attribute and
      // sends it as customer.phone. Skipping it means the number never arrives.
      // Runs for both modes so a build added normally still carries it.
      await persistPhoneToCart();

      if (!isQuotation) {
        try {
          // 4️⃣ Prepare Sections (Borrowing from product-form)
          const sections = productForm?.getSectionsToRender?.().map((s) => s.section) || [];

        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              ...buildPayload,
              sections: sections,
              sections_url: window.location.pathname
            })
          });

          const json = await response.json();

          if (json.status) {
            // Handle Error (Borrowing native error handler if it exists)
            if (productForm?.handleErrorMessage) {
              productForm.handleErrorMessage(json.description);
            } else {
              alert(json.description);
            }
            return;
          }

          // 5️⃣ SUCCESS: Trigger Theme UI Update
          // This is the "magic" part that updates the drawer/mini-cart
          if (productForm?.renderContents) {
            productForm.renderContents(json);
          }

          // Dispatch the event the theme listens for to open the cart
          window.dispatchCustomEvent?.('cart:item-added', {
            product: json.hasOwnProperty('items') ? json.items[0] : json
          });

        } catch (err) {
          console.error('Cart Error:', err);
        } finally {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
        }
      } else {
        // ... Your Quotation Logic stays the same ...
      }
    });

  
  
    bindImageDrawerOpener({
    imageSelector: '.nbn-grip-image img',
    drawerSelector: '#grip-drawer'
  });


  document.addEventListener("click", (e) => {
      // 1. Check if the clicked element is the overlay
      // console.log('e',e)
      if (e.target.matches(".nbn-drawer-overlay")) {
        
        // 2. Since it's the overlay, we close the drawers
        drawerClose("shaft-drawer");
        drawerClose("grip-drawer");
        
        // Optional: add a specific close for the ferrule drawer if you added one
        // drawerClose("ferrule-drawer"); 
      }
  });

});
